import './bootstrap';
import Swal from "sweetalert2";
import {initDesignBoard} from "./admin/designBoard/designBoard.js";
import {initDesignBoardIndex} from "./admin/designBoard/designBoards.js";
import {initPunchlists} from "./admin/punchlist/punchlist.js";
import {initSignup} from "./domains/signup.js";
import {initLoginAsUser} from "./loginAsUser/loginAsUser";
import {initSiteVisitShow} from "./siteVisits/show";
import {initCustomerCalendarIndex} from "./calendar";
import {initNotificationsSettingsIndex} from "./admin/notifications-settings";
import {initCustomerBudgetView} from "./budget/view";
import {initCustomerVendorPaymentIndex} from "./vendor-payments";
import {initCustomerDocumentsIndex} from "./projects/documents";
import {initCustomerDesignStudioShowView} from "./design-studio/view";
import {initCustomerTimelineShow} from "./timeline/show";
import {initCustomerDesignStudioShowSummary} from "./design-studio/summary";
import {initCustomerChangeOrdersIndex} from "./change-orders";
import {initCustomerIncomingInvoicesIndex} from "./incoming-invoices";
import {initCustomerChangeOrdersView} from "./change-orders/view";

window.Popper = require('popper.js').default

const routes = [{
	test: /\/punchlist/,
	action: () => initPunchlists(true),
},
	{
		test: /\/convenience-punchlist/,
		action: () => initPunchlists(true, 'convenience'),
	},
	{
		test: /\/signup/,
		action: initSignup,
	},
	{
		test: /\/design-board\/\d+$/,
		action: () => initDesignBoardIndex(true),
	},
	{
		test: /\/design-board\/\d+\/(create|post)(\/\d+\/edit)?$/,
		action: () => initDesignBoard(true),
	},
	{
		test: /\/vendor_payments\/\d+$/,
		action: () => {
			alert('TODO')
		},
	},
	{
		test: /\/calendar\/\d+$/,
		action: initCustomerCalendarIndex,
	},
]

// TODO: Migrate all routes from test based to explicit component import
const components = {
	'notifications-settings.index': {
		action: () => initNotificationsSettingsIndex(false),
	},

	'budgets.view': {
		action: initCustomerBudgetView,
	},

	'customer.vendor-payments.index': {
		action: initCustomerVendorPaymentIndex,
	},

	'customer.incoming-invoices.index': {
		action: initCustomerIncomingInvoicesIndex,
	},


	'customer.project-documents.index': {
		action: initCustomerDocumentsIndex,
	},

	'site-visits.show': {
		action: initSiteVisitShow,
	},

	/** Design Studio */

	'design-studio.view': {
		action: initCustomerDesignStudioShowView,
	},
	'projects.design-studio.summary': {
		action: initCustomerDesignStudioShowSummary,
	},

	/** Timeline */

	'project.timeline.show': {
		action: initCustomerTimelineShow,
	},

	/** Change Orders */

	'customer.change-orders.index': {
		action: initCustomerChangeOrdersIndex,
	},
	'customer.change-orders.view': {
		action: initCustomerChangeOrdersView,
	}
}

document.addEventListener('DOMContentLoaded', () => {

	let url = window.location.href.split('?')[0]; // Remove query
	url = url.replace('#', ''); // remove hash

	routes.forEach(route => {
		if (url.match(route.test)) {
			route.action();
		}
	})

	// Manually load Swal to window, for all old references
	window.Swal = Swal;

	// Remove inline styles from dom tree, as those are loaded on the css bundle
	document.querySelectorAll('style').forEach(styleTag => {
		if (styleTag.innerHTML.startsWith('.swal2-popup.swal2-toast')) {
			styleTag.remove();
		}
	});

	// Init components
	if (window.components) {
		window.components.forEach(componentKey => {
			if (components[componentKey]) {
				components[componentKey].action();
			} else {
				console.error(`"${componentKey}" component not found`);
			}
		})
	}

	initLoginAsUser();
})
